import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { useHistory } from "react-router-dom";
import { SubMenuList, URLS } from "@constants";
import "./css/SubNavigation.scss";
import { fixUrlLanguage } from "@utils/changeLanguage";

export const SubNavigation = () => {
    const history = useHistory();

    const getTabsValue = history.location.pathname.includes(fixUrlLanguage(URLS.ACCOUNT_DETAILS_PAGE_URL_EN))
        ? fixUrlLanguage(URLS.ACCOUNT_DETAILS_PAGE_URL_EN)
        : history.location.pathname;

    return (
        <Tabs
            className="subNavigation"
            classes={{ scroller: "subNavigation__scroll" }}
            scrollButtons="auto"
            value={getTabsValue}
            variant="scrollable"
        >
            {SubMenuList.map((link) =>
                link.isExternal ? (
                    <Tab component="a" disableRipple href={link.url} key={link.label} label={link.label} />
                ) : (
                    <Tab
                        disableRipple
                        key={link.label}
                        label={link.label}
                        value={fixUrlLanguage(link.url)}
                        onClick={() => history.push(fixUrlLanguage(link.url))}
                    />
                )
            )}
        </Tabs>
    );
};
